export default __webpack_public_path__ + "static/media/h3.9c432ce8.jpg";